import { useEffect, useState } from 'react';

import { getDunningLevels } from '../../../api';
import { logError } from '../../../logging/loggingService';

export default function useDunningLevels() {
    const [levels, setLevels] = useState([]);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await getDunningLevels();
                if (cancelled) return;
                setLevels(Array.isArray(res?.data) ? res.data : []);
            } catch (err) {
                logError('Failed to load dunning levels', err);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return levels;
}
